import { combineReducers } from 'redux';

import timer from './timer.reducer';

export default combineReducers({ timer });
